<!--
 * @Author: niuziji 18752021112@163.com
 * 退件审核
-->
<template>
  <div class="main-wrap application">
    <div class="application-top">
      <el-button type="primary" @click="auditConfirmation" :disabled="selectList.length===0" class="h40" plain>{{ $lang('审核确认') }}</el-button>
      <el-button type="primary" @click="turnDownVisible = true" :disabled="selectList.length===0" class="h40" plain>{{ $lang('驳回') }}</el-button>
      <div class="application-topLeft">
        <el-form :model="searchParam" ref="seach" :inline="true">
          <el-form-item prop="date">
            <el-date-picker
              :clearable="false"
              v-model="searchParam.date"
              type="daterange"
              :default-time="['00:00:00', '23:59:59']"
              :range-separator="$lang('至')"
              :start-placeholder="$lang('开始日期')"
              :end-placeholder="$lang('结束日期')"
              class="commonSize"
              @change="selectDate"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="waybillIds">
            <base-input-tag
              style="width: 210px"
              v-model="searchParam.waybillIds"
              :placeholder="$lang('请输入运单编号(最多可查100条)')"
              :clearBtnVisible="true"
              :addTagOnBlur="true"
              ref="BaseInputTag1"
              class="cms-input-tag"
            >
            </base-input-tag>
          </el-form-item>
          <el-form-item prop="orderNos">
            <base-input-tag
              style="width: 210px"
              v-model="searchParam.orderNos"
              :placeholder="$lang('请输入客户订单号(最多可查100条)')"
              :clearBtnVisible="true"
              :addTagOnBlur="true"
              ref="BaseInputTag2"
              class="cms-input-tag"
            >
            </base-input-tag>
          </el-form-item>
          <el-form-item prop="status">
            <el-select v-model="searchParam.status"  :placeholder="$lang('请选择订单来源')" class="vipsBox">
              <el-option
                v-for="(item, index) in approvalStatusList"
                :key="index"
                :label="$lang(item.label)"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="iconfont iconchaxun" class="h32" @click="searchChange">{{ $lang('查询') }} </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain icon="iconfont iconshanchu" class="h32" @click="resetSearch">{{ $lang('清空') }} </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="application-table">
      <JmsTable
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @row-del="rowDel"
        @size-change="sizeChange"
        @selection-change="selectionChange"
        @current-change="currentChange"
      >
        <!-- 运单号 -->
        <template slot="waybillNo" slot-scope="scope">
          <el-tooltip placement="top">
            <div style="text-align: center;" slot="content">{{scope.row.waybillNo}}</div>
            <span @click="getExpressTracking(scope.row.waybillNo)" style="color:#e60000;" class="getExpressTracking">{{ scope.row.waybillNo }}</span>
          </el-tooltip>
        </template>
        <template slot="menu" slot-scope="scope">
          <div>
            <el-button @click="rowView(scope.row)" type="text">{{ $lang('查看') }}</el-button>
          </div>
        </template>
      </JmsTable>
    </div>
    <!-- 驳回弹框 -->
    <TurnDownDialog :turnDownVisible.sync="turnDownVisible" :selectList="selectList" @successFn="successFn" />
    <!-- 详情弹框 -->
    <ReturnApplicationDetail ref="returnApplicationRef" :viewDialogVisible.sync='viewDialogVisible' @closeDetails='closeDetails' :bulletTitle='1' :rowData='rowData'></ReturnApplicationDetail>
  </div>
</template>

<script>
import { commonFun } from '@utils/common'
import { RESPONSE_SUCCESS } from '@constants'
import JmsTable from '@/components/jms-widget/jms-table'
import mixin from '@/mixins/mixin.js'
import TurnDownDialog from './components/TurnDownDialog'
import ReturnApplicationDetail from './components/ReturnApplicationDetail'
import { problemExpressPage, findDetail, expressAudit } from '@api/module/customer'
export default {
  name: 'ReturnApplication',
  mixins: [mixin],
  components: {
    JmsTable,
    TurnDownDialog,
    ReturnApplicationDetail
  },
  data() {
    return {
      COM_HTTP: {
        reqList: problemExpressPage, // 列表
        reqDetail: findDetail, // 详情
      },
      viewDialogVisible: false, // 详情
      turnDownVisible: false, // 驳回
      isRowDetaiilUrl: true,
      searchParam: {
        date: commonFun.GetTodayDate(),
        applyTimeFrom: commonFun.GetTodayDate()[0], // 开始时间
        applyTimeTo: commonFun.GetTodayDate()[1], // 结束时间
        waybillIds: [], // 运单号
        orderNos: [], // 客户订单号
        status: 1, // 审核状态
      },
      approvalStatusList: [
        {
          label: '审核中',
          value: 1
        },
        {
          label: '审核通过',
          value: 2
        },
        {
          label: '驳回',
          value: 4
        },
      ],
      selectList: [],
    }
  },
  computed: {
    listOpt () {
      return {
        border: true,
        selection: true,
        menu: true,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        rowKey: '$index',
        fixHeight: 90,
        menuWidth: 150,
        //  搜索框和表格列及其字段
        column: [
          {
            label: '运单编号',
            prop: 'waybillNo',
            slot: true
          },
          {
            label: '客户订单号',
            prop: 'orderNo',
          },
          {
            label: '申请类型',
            prop: 'applyTypeName',
          },
          {
            label: '申请状态',
            prop: 'statusName',
          },
          {
            label: '揽收/订单所属网点',
            prop: 'senderNetworkName',
            width: 150
          },
          {
            label: '申请网点',
            prop: 'applyNetworkName',
          },
          {
            label: '申请时间',
            prop: 'applyTime',
          },
          {
            label: '申请人',
            prop: 'applyStaffName',
          },
          {
            label: '审核网点',
            prop: 'examineNetworkName',
          },
          {
            label: '审核时间',
            prop: 'examineTime'
          },
          {
            // 申请来源 1人工录入 2问题件录入 3 总部工单
            label: '申请来源',
            prop: 'applySourceName',
          },
          {
            label: '备注信息',
            prop: 'reason',
          },
        ],
      }
    },
  },
  methods: {
    getExpressTracking(waybillId) {
      this.$router.push({ path: '/expressTracking', query: { waybillId }})
    },
    searchChange() {
      const { waybillIds, applyTimeFrom, applyTimeTo } = this.searchParam
      const space = 30 * 24 * 3600 * 1000
      const startTime = new Date(applyTimeFrom).getTime()
      const endTime = new Date(applyTimeTo).getTime()
      if ((endTime - startTime) > space) {
        this.$message.error(this.$lang('开始时间与结束时间之差不能大于30天'))
        return
      }
      // 处理运单编号
      if (waybillIds && waybillIds.length !== 0) {
        if (waybillIds.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条运单'))
        }
      }
      this.searchFun(1)
    },
    // 审核确认
    auditConfirmation() {
      const title = this.$lang('正在进行审核确认操作, 请确认!')
      const tip = this.$lang('温馨提示')
      this.$confirm(title, tip, {
        confirmButtonText: this.$lang('确定'),
        cancelButtonText: this.$lang('取消'),
        type: 'warning'
      }).then(async () => {
        const waybillIds = this.selectList.map((item) => item.waybillNo)
        const params = {
          waybillIds
        }
        const { code, data, msg } = await expressAudit(params)
        if (code === RESPONSE_SUCCESS) {
          if (!data) {
            return this.$message.error(this.$lang('审核失败'))
          }
          this.$message.success(this.$lang('审核成功'))
          this.searchChange()
        } else {
          this.$message.error(msg)
        }
      })
    },
    // 选择日期
    selectDate () {
      if (this.searchParam.date) {
        const [start = '', end = ''] = this.searchParam.date
        this.searchParam.applyTimeFrom = start
        this.searchParam.applyTimeTo = end
      }
    },
    // 复选框选中
    selectionChange(val) {
      // 只有审核中的数据才可以选中
      if (this.searchParam.status !== 1) {
        return
      }
      this.selectList = val
    },
    // 驳回成功回调
    async successFn() {
      this.$message.success(this.$lang('驳回成功'))
      this.selectList = []
      this.searchChange()
    },
    // 获取查看详情
    async rowView(row) {
      const params = {
        waybillNo: row.waybillNo,
        applyTypeCode: row.applyTypeCode
      }
      await this.viewFun(row, params)
      this.rowData = Object.assign(this.handleData(row), this.rowData)
      this.viewDialogVisible = true
    },
    getParams () {
      const { applyTimeFrom, applyTimeTo, waybillIds, status, orderNos } = this.searchParam
      const params = {
        applyTimeFrom,
        applyTimeTo,
        waybillIds,
        status,
        orderNos
      }
      return Object.assign({}, params)
    },
    // 重置
    resetSearch() {
      this.searchParam = {
        waybillIds: [],
        status: 1,
        date: commonFun.GetTodayDate(),
        applyTimeFrom: commonFun.GetTodayDate()[0],
        applyTimeTo: commonFun.GetTodayDate()[1],
      }
      this.$refs.BaseInputTag1.clearFn()
      this.$refs.BaseInputTag2.clearFn()
    }
  }
}
</script>

<style lang="scss" scoped>
.application {

  .application-top {
    padding: 16px 24px;

    .commonSize {
      width: 328px !important;
      height: 32px !important;
    }
    .application-topLeft {
      margin-top: 10px;
    }
  }

  .application-table {
    padding: 12px 24px;
  }
}
</style>

